<div class="flash-message-container">
  <flash-message></flash-message>
</div>

<div class="row">
  <div class="col-xs-12">
    <div class="panel panel-default no-margin">
      <div class="panel-body">
        <div class="row">
          <div class="col-xs-12">
            <h3>Básico</h3>
          </div>

          <div class="col-md-6">
            <div class="form-group" ng-class="{'has-error': usuario_form.nomeCompleto.$invalid}">
              <label for="nomeCompleto">Nome</label>
              <input class="form-control" ng-model="newUsuario.nomeCompleto" type="text" id="nomeCompleto" name="nomeCompleto" placeholder="Nome Completo" required>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group" ng-class="{'has-error': usuario_form.email.$invalid}">
              <label for="email">Email</label>
              <input class="form-control" ng-model="newUsuario.email" type="email" id="email" name="email" placeholder="nome@empresa.com.br" ng-required="newUsuario.utilizaMobile">
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group" ng-class="{'has-error': usuario_form.telefone.$invalid}">
              <label for="telefone">Telefone</label>
              <input class="form-control" text-mask="PHONE_MASK" ng-model="newUsuario.telefone" type="text" id="telefone" name="telefone" placeholder="(99) 99999-9999">
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group" ng-class="{'has-error': usuario_form.cpf.$invalid}">
              <label for="cpf">CPF</label>
              <input class="form-control" text-mask="CPF_MASK" ng-model="newUsuario.cpf"
                     type="text" id="cpf" name="cpf" placeholder="999.999.999-99"
                     ng-change="resetErrors()" required ng-readonly="readonlyCPF">
              <span ng-repeat="erroCPF in erroCPFLoginUnificado">
                {{erroCPF}}
              </span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <h3>Acesso</h3>
          </div>

          <div class="col-md-4">
            <div class="form-group" ng-class="{'has-error': usuario_form.login.$invalid || erroNomeDuplicado}">
              <label for="login">Login</label>
              <input class="form-control" ng-model="newUsuario.nome" type="text" id="login" name="login" autocomplete="false" maxlength="20" required>
              <span class="help-block" ng-if="erroNomeDuplicado">Este login já está em uso, por favor escolha outro.</span>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group" ng-class="{'has-error': usuario_form.senha.$invalid }">
              <label for="login">Senha</label>
              <input class="form-control" ng-model="newUsuario.senha" type="password"
                     id="senha" name="senha" autocomplete="new-password" ng-required="!newUsuario.id">
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group" ng-class="{'has-error': usuario_form.confirmaSenha.$invalid }">
              <label for="login">Confirmar Senha</label>
              <input class="form-control" ng-model="newUsuario.confirmaSenha" type="password"
                     id="confirmaSenha" name="confirmaSenha" autocomplete="new-password" ng-required="!newUsuario.id">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <h3>Configurações</h3>
          </div>

          <div class="col-md-4">
            <div class="form-group" ng-class="{'has-error': usuario_form.funcao.$invalid }">
              <label for="funcao">Função</label>
              <ui-select ng-model="newUsuario.funcao" theme="bootstrap" id="funcao" name="funcao" ng-required="newUsuario.utilizaMobile">
                <ui-select-match allow-clear="true" placeholder="Selecione a Função...">{{$select.selected.descricao | humanize}}</ui-select-match>
                <ui-select-choices repeat="funcao in funcoes | filter: $select.search">
                  <span class="form-group" ng-bind-html="funcao.descricao | humanize | highlight: $select.search"></span>
                </ui-select-choices>
              </ui-select>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label for="cor">Cor</label>
              <color-picker ng-model="newUsuario.cor" id="cor" name="cor" options="colorOptions"></color-picker>
            </div>
          </div>

          <div class="col-md-4">
            <br>
            <div class="checkbox">
              <label>
                <input type="checkbox" ng-model="newUsuario.utilizaMobile"> Utiliza Mobile
              </label>
            </div>
          </div>
        </div>

        <div class="row" ng-if="newUsuario.utilizaMobile">
          <div class="col-md-12">
            <div class="form-group" ng-class="{'has-error': !checkedPropriedade() }">
              <label>Propriedades</label>
              <div class="col-xs-12 no-margin">
                <span class="btn label label-default" ng-click="checkedAllPropriedades()">Todas</span>
                <span class="btn label label-default" ng-click="uncheckedAllPropriedades()">Nenhuma</span>
              </div>
              <div class="col-xs-12 checkbox no-margin" ng-repeat="propriedade in newUsuario.allPropriedades">
                <label>
                  <input class="btn" type="checkbox" ng-model="propriedade.selected"/>
                  {{::propriedade.descricao | capitalize}}
                  <small ng-show="propriedade.produtor.id" class="text-muted">
                    (Produtor: {{::propriedade.produtor.nome | capitalize}})
                  </small>
                </label>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>
